<template>
  <div class="x-audio-wrap" :class="{inline:!block}" ref="wrap" @click="play">
    <div class="x-sector" :class="{play:animate}">
      <div class="x-dot"></div>
    </div>
    <div class="x-time">{{duration&&showDuration?duration:text}}</div>
  </div>
</template>

<script>
export default {
  name: 'ipsosAudio',
  props: {
    src: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '轻触播放'
    },
    showDuration: {
      type: Boolean,
      default: true
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      audio: null,
      animate: false,
      timer: null,
      duration: null
    }
  },
  created () {
    window.audioList = window.audioList || []
  },
  mounted () {
    this.audio = new Audio()
    this.audio.src = this.src
    this.audio.addEventListener('canplaythrough', () => {
      this.duration = this.format(this.audio.duration)
    })
    this.audio.onplay = () => {
      this.animate = true
      this.timer = setInterval(() => {
        this.animate = false
        setTimeout(() => {
          this.animate = true
        }, 50)
      }, 1250)
    }
    this.audio.onpause = () => {
      this.animate = false
      this.timer && clearInterval(this.timer)
    }
    this.audio.onended = () => {
      this.animate = false
      this.timer && clearInterval(this.timer)
    }
    window.audioList.push(this.audio)// 所有实例加入全局变量
  },
  methods: {
    play () {
      window.audioList.forEach(audio => { // 开始前先关闭所有可能正在运行的实例
        if (audio !== this.audio) {
          audio.pause()
        }
      })
      if (this.audio.paused) {
        this.audio.play()
      } else {
        this.audio.pause()
      }
    },
    format (s) {
      var t = ''
      if (s > -1) {
        var min = Math.floor(s / 60) % 60
        var sec = s % 60
        if (min < 10) { t += '0' }
        t += min + "'"
        if (sec < 10) { t += '0' }
        t += sec.toFixed(2)
      }
      t = t.replace('.', '"')
      return t
    }
  }
}
</script>

<style lang="scss" scoped>
  $audio-border-color: #fff;
  .x-audio-wrap{
    height: 60px;
    width: 100%;
    border-radius: 35px;
    background: rgba(102, 153, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
    .x-sector{
      height: 14px;
      width: 14px;
      border-radius:2px 16px;
      border-right: 2px solid $audio-border-color;
      border-top: 2px solid $audio-border-color;
      transform: rotate(45deg);
      position: relative;
      margin-left: 26px;
      .x-dot{
        height: 8px;
        width: 8px;
        border-radius: 50%;
        background: $audio-border-color;
        position: absolute;
        top: 4px;
      }
    }
    .x-sector::before{
      content: "";
      height: 18px;
      width: 18px;
      border-radius:4px 36px;
      border-right: 2px solid $audio-border-color;
      border-top: 2px solid $audio-border-color;
      transform: rotate(0deg);
      position: absolute;
      right: -8px;
      top: -8px;
    }
    .x-sector::after{
      content: "";
      height: 24px;
      width: 24px;
      border-radius:4px 36px;
      border-right: 2px solid $audio-border-color;
      border-top: 2px solid $audio-border-color;
      transform: rotate(0deg);
      position: absolute;
      right: -14px;
      top: -14px;
    }

    .x-time{
      color: $audio-border-color;
      font-size: 12px;
      margin-right: 26px;
    }
    &.inline{
      display: inline-flex
    }
  }
  @keyframes play-dot{
    from{
      background: #ddd
    }
    to{
      background: #5cadff
    }
  }
  @keyframes play-sector{
    from{
      border-color: $audio-border-color
    }
    to{
      border-color: #5cadff
    }
  }
  .x-sector.play{
    animation: play-sector 0.3s 0.1s ease-in-out;
  }
  .x-sector.play::before{
    animation: play-sector 0.3s 0.2s ease-in-out;
  }
  .x-sector.play::after{
    animation: play-sector 0.3s 0.3s ease-in-out;
  }
  .x-sector.play .x-dot{
    animation: play-dot 0.3s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuAudio.vue